import React, { useEffect, useState } from 'react'
import { AiFillEdit } from 'react-icons/ai';
import { MdDelete } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom';
import AppLayout from '../components/AppLayout';
import { editPlan, getPlan } from '../logic/plans/action';
import {v4 as uuidv4} from 'uuid'

const Plans = () => {
    const dispatch = useDispatch(); 
    const selector = useSelector(state=>state.plans);
    const [features, setfeatures] = useState([]);
    const [open, setopen] = useState(false);
  // const dispatch = useDispatch();
  // const navigate = useNavigate();
  const [data, setdata] = useState({
    id:0,
    name:'',
    price:10,
    customer_limit:0,
    staff_limit:0,
    appointment_limit:0,
    storage_limit:0,
    service_limit:0,
    sms_limit:0,
  });

    useEffect(() => {
      getPlan(dispatch);
    //   getPlan(dispatch);
    }, []);

    const editplanClick = ()=>{
      console.log('clicked');
        editPlan(dispatch,{...data,features:features.map(e=>e.value).join('-'),fetures:features.map(e=>e.value).join('-')});
        setopen(false);
    }
    const closeEditPopup = () =>{
      setopen(false)
    }
  return (
    <AppLayout>
    <div className="flex-1 h-full flex flex-col items-start gap-10 p-10 justify-center">
      <div className="flex justify-between w-full">
        <h1 className="font-bold text-2xl">Plans</h1>
        <Link to={"/admin/plans/add"}>
          <button className="w-12 h-12 rounded-full">+</button>
        </Link>
      </div>
      <div className={`w-screen h-screen bg-black/40 ${open?'flex':'hidden'} items-center justify-center fixed top-0 left-0`}>
          <div className='w-1/2 h-1/2 p-10 overflow-y-scroll flex flex-col items-center gap-4 bg-white rounded-lg'>
          <div className='w-[100%] flex items-end justify-end'>
          <button className=" text-gray-600 hover:text-gray-900" onClick={closeEditPopup}>X</button>
          </div>
          <div className='flex items-center'>
          <h2>Edit plan</h2>
        </div>
              <div className='w-full flex flex-col items-start gap-2'>
        <label htmlFor="name">Plan Name</label>
        <input placeholder='Plan Name' name='name' id='name' value={data.name} onChange={(ev)=>{setdata(prev=>({...prev,[ev.target.name]:ev.target.value}))}}/>
          </div>
          <div className='w-full flex flex-col items-start gap-2'>
        {/* <input placeholder='Plan Price'/> */}
        <label htmlFor="patient_limit">Patient Limit</label>
        <input placeholder='Patient Limit' name='patient_limit' id='patient_limit' value={data.patient_limit || data.customer_limit} onChange={(ev)=>{setdata(prev=>({...prev,[ev.target.name]:ev.target.value}))}}/>
          </div>
          <div className='w-full flex flex-col items-start gap-2'>
        <label htmlFor="staff_limit">Staff Limit</label>
        <input placeholder='Staff Limit' name='staff_limit' id='staff_limit' value={data.staff_limit} onChange={(ev)=>{setdata(prev=>({...prev,[ev.target.name]:ev.target.value}))}}/>
          </div>
          <div className='w-full flex flex-col items-start gap-2'>
        <label htmlFor="storage_limit">Storage Limit</label>
        <input placeholder='Storage Limit' name='storage_limit' id='storage_limit' value={data.storage_limit} onChange={(ev)=>{setdata(prev=>({...prev,[ev.target.name]:ev.target.value}))}}/>
          </div>
          <div className='w-full flex flex-col items-start gap-2'>
        <label htmlFor="service_limit">Service Limit</label>
        <input placeholder='Service Limit' name='service_limit' id='service_limit' value={data.service_limit} onChange={(ev)=>{setdata(prev=>({...prev,[ev.target.name]:ev.target.value}))}}/>
          </div>
          <div className='w-full flex flex-col items-start gap-2'>
        <label htmlFor="appointment_limit">Appointment Limit</label>
        <input placeholder='Appointment Limit' name='appointment_limit' id='appointment_limit' value={data.appointment_limit} onChange={(ev)=>{setdata(prev=>({...prev,[ev.target.name]:ev.target.value}))}}/>
          </div>
          <div className='w-full flex flex-col items-start gap-2'>
        <label htmlFor="ams_limit">SMS Limit</label>
        <input placeholder='SMS Limit' name='sms_limit' id='sms_limit' value={data.sms_limit} onChange={(ev)=>{setdata(prev=>({...prev,[ev.target.name]:ev.target.value}))}}/>
          </div>
        <div className='flex items-center justify-between w-full'>
          <p>Add Feature</p>
          <button
          onClick={()=>setfeatures(prev=>([...prev,{
            id:uuidv4(),
            value:''
          }]))}
          >+</button>
        </div>
        {
          features.map(
            (e,i)=>
        <div className='flex items-stretch gap-4 w-full' key={i}>
          <input type="text" placeholder='add feture' value={e.value} onChange={(ev)=>
          {
            let arr = [...features];
            arr[i].value = ev.target.value;
            setfeatures(arr);
          }
          }/>
          <button onClick={()=>setfeatures(prev=>prev.filter(el=>el.id!==e.id))} className='flex items-center justify-center'><MdDelete/></button>
        </div>
          )
        }
        <button onClick={editplanClick}>EDIT PLAN</button>
          </div>
      </div>
      <div className="w-full h-[80%] flex flex-col shadow-lg gap-4">
          <div className="py-4 h-auto flex w-full bg-gray-500 text-white font bold">
            <p className="flex-1 text-center">Id</p>
            <p className="flex-1 text-center">Plan</p>
            <p className="flex-1 text-center">Staff Limit</p>
            <p className="flex-1 text-center">Patient Limit</p>
            <p className="flex-1 text-center">Storage Limit</p>
            <p className="flex-1 text-center">SMS Limit</p>
            <p className="flex-1 text-center">See Prices</p>
            <p className="flex-1 text-center">Action</p>
          </div>
          <div className="flex-1 overflow-y-scroll">
            {
                selector?.plans?.map(
                    (e,i)=><div className='py-4 flex w-full border-b-[0.1px] border-gray-500 font bold' key={i}>
                        <p className='flex-1 text-center capitalize'>{e?.id}</p>
                        <p className='flex-1 text-center capitalize'>{e?.name}</p>
                        {/* <p className='flex-1 text-center capitalize'>{e?.price}</p> */}
                        <p className='flex-1 text-center capitalize'>{e?.staff_limit === 100000 ? 'Unlimited':e?.staff_limit}</p>
                        <p className='flex-1 text-center capitalize'>{e?.customer_limit === 100000 ? 'Unlimited':e?.customer_limit}</p>
                        <p className='flex-1 text-center capitalize'>{e?.storage_limit>1024? e?.storage_limit / 1024 : e?.storage_limit} {e?.storage_limit>1024? 'GB' : 'MB'}</p>
                        <p className='flex-1 text-center capitalize'>{e?.sms_limit === 100000 ? 'Unlimited':e?.sms_limit}</p>
                        <p className='flex-1 text-center capitalize text-blue-500 underline'>
                           <Link to={`/admin/plans/${e?.id}`}>
                           see
                           </Link> 
                        </p>
                        <p className="flex-1 text-center">
                  <span className="flex gap-4 justify-center items-center">
                    <AiFillEdit
                      className="cursor-pointer"
                      onClick={()=>{
                        setdata({
                          id:e?.id,
    name:e?.name,
    price:e?.price,
    customer_limit:e?.customer_limit,
    staff_limit:e?.staff_limit,
    appointment_limit:e?.appointment_limit,
    storage_limit:e?.storage_limit,
    service_limit:e?.service_limit,
    sms_limit:e?.sms_limit,
                        });
                        setfeatures(e?.features ? e.features.split('-').map(em=>({id:uuidv4(),value:em})) : []);
                        setopen(true);
                      }}
                      // onClick={setEditMode}
                    />
{/* {
e?.id
<MdDelete color='red'/>
} */}
                  </span>
                </p>
                    </div>
                )
            }
          </div>
          </div>
      </div>
    </AppLayout>
  )
}

export default Plans